import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {App as AntdApp} from "antd";
import {
	Button,
	Loading,
	FontAwesomeIcon
} from "~/components";
import {InputField, AddressFields} from "~/components/Forms";
import {apiError, handleRequest} from "~/utils";
import {authApi} from "~/api";
import {globalNavigate} from "~/routes/GlobalHistory";

const PHONE_REGEX = /^(0|\+84)(\d{9,10})$/;

function AuthRegisterForm() {

	const {notification} = AntdApp.useApp();

	const initialValues = {
		lastname: '', firstname: '', username: '', email: '', phone: '',
		password: '', confirmPassword: '', city: null, ward: null, address: '',
	}

	const validationSchema = Yup.object().shape({
		lastname: Yup.string().required('Họ không được để trống'),
		firstname: Yup.string().required('Tên không được để trống'),
		username: Yup.string().required('Tên đăng nhập không được để trống').min(5, 'Tên đăng nhập quá ngắn'),
		email: Yup.string().required('Email không được để trống').email('Email không hợp lệ'),
		phone: Yup.string().required('Số điện thoại không được để trống').matches(PHONE_REGEX, 'Số điện thoại không hợp lệ'),
		password: Yup.string().required('Mật khẩu không được để trống').min(6, 'Mật khẩu tối thiểu 6 ký tự'),
		confirmPassword: Yup.string().required('Vui lòng nhập lại mật khẩu').oneOf([Yup.ref('password')], 'Mật khẩu nhập lại không khớp'),
	})

	const { control, handleSubmit, setValue, formState: { isSubmitting, errors } } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const onSubmit = async (data) => {

		const {confirmPassword, ...params} = data;

		let [error, response] = await handleRequest(authApi.register(params));

		let message = apiError(`Đăng ký thất bại`, error, response);

		if(!message) {
			notification.success({message: 'Đăng ký thành công', description: 'Vui lòng đăng nhập để tiếp tục.'});
			globalNavigate(process.env.REACT_APP_HOMEPAGE+"/login");
		}
	}

	return (
        <form className="form" onSubmit={handleSubmit(onSubmit)}>
            {isSubmitting && <Loading/>}

            <div className="mform-grid-2">
                <Controller control={control} name="lastname"
                            render={({field}) => (
                                <InputField label="Họ" placeholder="Nguyễn Văn" errors={errors} {...field}/>
                            )}
                />
                <Controller control={control} name="firstname"
                            render={({field}) => (
                                <InputField label="Tên" placeholder="A" errors={errors} {...field}/>
                            )}
                />
            </div>

            <Controller control={control} name="username"
                        render={({field}) => (
                            <InputField label="Tên đăng nhập" placeholder="Tên đăng nhập"
                                        autoComplete="username"
                                        prefix={<FontAwesomeIcon icon="fa-light fa-user" className="color-grey"/>}
                                        errors={errors} {...field}/>
                        )}
            />
            <Controller control={control} name="email"
                        render={({field}) => (
                            <InputField label="Email" placeholder="you@example.com"
                                        autoComplete="email"
                                        prefix={<FontAwesomeIcon icon="fa-light fa-envelope" className="color-grey"/>}
                                        errors={errors} {...field}/>
                        )}
            />
            <Controller control={control} name="phone"
                        render={({field}) => (
                            <InputField label="Số điện thoại" placeholder="0901234567"
                                        autoComplete="tel"
                                        prefix={<FontAwesomeIcon icon="fa-light fa-phone" className="color-grey"/>}
                                        errors={errors} {...field}/>
                        )}
            />

            <div className="mform-grid-2">
                <Controller control={control} name="password"
                            render={({field}) => (
                                <InputField label="Mật khẩu" type="password" placeholder="Tối thiểu 6 ký tự"
                                            autoComplete="new-password"
                                            prefix={<FontAwesomeIcon icon="fa-light fa-lock" className="color-grey"/>}
                                            errors={errors} {...field}/>
                            )}
                />
                <Controller control={control} name="confirmPassword"
                            render={({field}) => (
                                <InputField label="Nhập lại mật khẩu" type="password" placeholder="Nhập lại mật khẩu"
                                            autoComplete="new-password"
                                            prefix={<FontAwesomeIcon icon="fa-light fa-lock" className="color-grey"/>}
                                            errors={errors} {...field}/>
                            )}
                />
            </div>

            <AddressFields control={control} errors={errors} setValue={setValue}/>

            <div className="form-group mt-3 d-flex justify-content-center">
                <Button background blue type="submit" className={'w-full pdt-2 pdb-2'}>
                    <FontAwesomeIcon icon="fa-light fa-user-plus"/> Đăng ký
                </Button>
            </div>
        </form>
    )
}

export default AuthRegisterForm;
